var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5458 0.746094L3.93134 0.746094C2.98711 0.746094 2.08154 1.12119 1.41387 1.78887C0.74619 2.45654 0.371094 3.36211 0.371094 4.30634L0.371094 16.1738C0.371094 17.1181 0.74619 18.0236 1.41387 18.6913C2.08154 19.359 2.98711 19.7341 3.93134 19.7341H20.5458C21.4901 19.7341 22.3956 19.359 23.0633 18.6913C23.731 18.0236 24.1061 17.1181 24.1061 16.1738V4.30634C24.1061 3.36211 23.731 2.45654 23.0633 1.78887C22.3956 1.12119 21.4901 0.746094 20.5458 0.746094ZM20.5458 3.11959L12.832 8.42436C12.6516 8.52852 12.4469 8.58336 12.2386 8.58336C12.0303 8.58336 11.8256 8.52852 11.6452 8.42436L3.93134 3.11959L20.5458 3.11959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a3c143d4276c26ef282b0f0f9b1dbbb0.svg";
export { ForwardRef as ReactComponent };